export enum AnswersType {
    NUMBER = "NUMBER",
    BOOL = "BOOL",
    TEXT = "TEXT",
    QUESTION_RATING = "QUESTION_RATING",
}
